import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { S10Response } from '../../../interfaces/auth.interface';
import { Company, Period, Scheme, VFlexColumnConfig } from '../../../interfaces/accountEntries.interface';
import { cleanDuplicates } from '../../../utils/data';


export interface AccountEntries {
    vFlexColumnsConfig: VFlexColumnConfig[] | null;
    companies: Company[];
    scheme: Scheme[];
    periods: Period[];
}

const initialState: AccountEntries = {
    vFlexColumnsConfig: null,
    companies: [],
    scheme: [],
    periods: []
}

export const accountEntries = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCompanies: (state, {payload}: PayloadAction<S10Response<Company[]>>) => {
            state.companies = payload.data;
        },
        setScheme: (state, {payload}: PayloadAction<S10Response<Scheme[]>>) => {
            state.scheme = payload.data;
        },
        setPeriods: (state, {payload}: PayloadAction<S10Response<Period[]>>) => {
            state.periods = cleanDuplicates(
                [
                    ...(state.periods || []), 
                    ...payload.data
                ],
                "CodPeriodoContable",
            ).sort((a, b) => b.CodPeriodoContable - a.CodPeriodoContable);
        },
        setVFlexConfig: (state, {payload}: PayloadAction<S10Response<VFlexColumnConfig[]>>) => {
            // console.log('setVFlexConfig', payload)
            state.vFlexColumnsConfig = cleanDuplicates(
                [
                    ...(state.vFlexColumnsConfig || []), 
                    ...payload.data
                ],
                "CampoCodigo",
            ).sort((a, b) => a.Posicion - b.Posicion);
        },
    }
})


export const { 
    setCompanies,
    setScheme,
    setPeriods,
    setVFlexConfig,
} = accountEntries.actions
